let confirm=(event, dialog)=>{
    if (!dialog) {
        let target=event.target.closest('[data-confirm-head],[data-confirm-prompt]');
        dialog = {
            head : target.dataset.confirmHead || '',
            prompt : target.dataset.confirmPrompt || ''
        }
    }

    let prompt=dialog.head?dialog.head+(dialog.prompt?'\n'+dialog.prompt:''):dialog.prompt;

    if (event.hasOwnProperty('isTrusted') && window.VutBox) {
        ret = !event.isTrusted;
        if (event.isTrusted) {
            try {
                window.VutBox.dialog(
                    {
                        head: dialog.head || '',
                        prompt: dialog.prompt || '',
                        buttons: [
                            {
                                name: window.jstr("Ano","Yes"),
                                callback: function () {
                                    event.target.click();
                                },
                                'class': 'btn-primary vutbox-close',
                            },
                            {
                                name: window.jstr("Zrušit","Cancel"),
                                'class': 'vutbox-close',
                            },
                        ]
                    }
                )
            } catch (e) {
                ret = window.confirm(prompt);
            }
        }
    } else {
        ret=window.confirm(prompt);
    }
    if (!ret) {
        try {
            event.preventDefault();
        } catch (e) {}
        try {
            event.stopPropagation();
        } catch (e) {}
        try {
            event.stopImmediatePropagation();
        } catch (e) {}
    }
    return ret;

}

window.addEventListener('click', (event)=>{
    if (event.hasOwnProperty('isTrusted') && !event.isTrusted) return true;
    if (event.target instanceof HTMLElement) {
        let target;
        let dialog;
        if ( (target = event.target.closest('[data-confirm-callback]')) && (target.dataset.confirmCallback)) {
            if (typeof window[target.dataset.confirmCallback] === 'function') {
                try {
                    dialog = window[target.dataset.confirmCallback](event);
                    if (dialog === true) return true;
                    if ((typeof dialog === 'object')&&dialog&&(dialog.prompt||dialog.head)) return confirm(event, dialog);
                } catch (e) {
                    console.error('chyba callback funkce '+target.dataset.confirmCallback);
                    console.error(e);
                }
            } else {console.error(target.dataset.confirmCallback + ' není platná funkce');}
        }

        if ( (target = event.target.closest('[data-confirm-head],[data-confirm-prompt]')) && (target.dataset.confirmHead||target.dataset.confirmPrompt) ) {
            return confirm(event);
        }


    }


}, true);